import { useId } from 'react';

import classNames from 'classnames';

import styles from '../Toast.module.css';

import { Button } from '../../Button';
import { Text } from '../../Text';
import type { ToastObj } from '../types';
import { ToastSentiment } from '../types';

type ToastDialogProps = ToastObj & {
  buttonLabel: string;
  /** Callback when the button is clicked. */
  onButtonClick: () => void;
};

/** Render a toast with role "alertdialog" with a button on the right. */
export function ToastDialog(props: ToastDialogProps) {
  const {
    sentiment = ToastSentiment.Positive,
    message,
    buttonLabel,
    onButtonClick,
  } = props;
  const labelId = useId();
  return (
    <div
      role="alertdialog"
      className={classNames(styles.toast, styles[sentiment])}
      aria-label={labelId}
    >
      <div role="document" className={styles.document}>
        <Text color="Kale3" id={labelId} className={styles.message}>
          {message}
        </Text>
        <Button type="button" variant="plain-text" onClick={onButtonClick}>
          <Text bold>{buttonLabel}</Text>
        </Button>
      </div>
    </div>
  );
}
